import { useEffect } from 'react';
import { useLoggerContext } from '@bingads-webui-cc-react/instrumentation-base';

export const useLogEntry = ({ componentName = '' } = {}) => {
  const { trace } = useLoggerContext();
  useEffect(() => {
    trace({
      message: `Component entry: ${componentName}`,
    });
  }, [componentName, trace]);
};
